import { useQuery } from '@tanstack/react-query';
import type { EnrichedVehicleSubscriptionResponse } from '@//app/api/protected/subscriptions/vehicles/enriched';
import { useAuth } from '@//providers/AuthProvider';
import { useApiBaseUrl } from '@//providers/MarketSettingsProvider';
import { httpClientGetAuthorizedJson } from '../../httpClient';

export const VEHICLE_SUBSCRIPTIONS_ENRICHED_CACHE_KEY =
  'api/protected/subscriptions/vehicles/enriched';

const useEnrichedVehicleSubscriptions = () => {
  const { initialized, decodedToken } = useAuth();
  const apiBaseUrl = useApiBaseUrl();
  const query = useQuery<EnrichedVehicleSubscriptionResponse>({
    queryKey: [VEHICLE_SUBSCRIPTIONS_ENRICHED_CACHE_KEY, decodedToken?.sub],
    queryFn: async () => {
      const url = `${apiBaseUrl}/api/protected/subscriptions/vehicles/enriched`;
      return await httpClientGetAuthorizedJson<EnrichedVehicleSubscriptionResponse>(url);
    },
    enabled: initialized,
  });

  return query;
};

export default useEnrichedVehicleSubscriptions;
